<template>
  <div class="app-container">
    <el-card>
      <el-descriptions title="用户信息">
        <el-descriptions-item label="头像">
          <el-avatar :src="order.avatar"></el-avatar>
        </el-descriptions-item>
        <el-descriptions-item label="用户名称">{{ order.nickname }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ order.phone }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- <el-card>
      <div slot="header">
        <span>收货信息</span>
      </div>
      <el-row>
        <el-col :span="24">
          <descriptions v-if="order.order_no" :column="1" :bordered="false">
            <descriptions-item label="订单编号">{{ order.order_no }}</descriptions-item>
            <descriptions-item v-if="order.receiver_address" label="收货人姓名">{{ order.receiver_name }}</descriptions-item>
            <descriptions-item v-if="order.receiver_address" label="收货人电话">{{ order.receiver_mobile }}</descriptions-item>
            <descriptions-item v-if="order.receiver_address" label="收货人地址">{{ order.receiver_address }}{{ order.receiver_address_name }}{{ order.receiver_address_floor }}{{ order.receiver_address_detail }}</descriptions-item>
            <descriptions-item v-if="order.memo" label="订单备注">{{ order.memo }}</descriptions-item>
          </descriptions>
        </el-col>
      </el-row>
    </el-card> -->

    <el-card>
      <div slot="header" style="display:flex;justify-content:space-between;align-items:center"><span>订单信息</span></div>

      <descriptions v-if="order.order_no" class="margin-top" :column="3" :size="size" :bordered="false">
        <descriptions-item label="订单类型">
          <template v-if="order.type == 1">场地</template>
          <template v-else-if="order.type == 3">会员卡</template>
          <template v-else-if="order.type == 4">套餐</template>
          <template v-else-if="order.type == 5">充值</template>
        </descriptions-item>
        <descriptions-item label="订单编号">{{ order.out_trade_no }}</descriptions-item>
        <descriptions-item v-if="order.type != 1" label="支付类型">{{ order.pay_type_name }}</descriptions-item>
        <descriptions-item v-if="order.type === 1" label="门店名称">{{ order.site_name }}</descriptions-item>
        <descriptions-item label="订单总金额">￥{{ order.total_price }}</descriptions-item>
        <descriptions-item label="实付总金额">￥{{ order.price }}</descriptions-item>
        <descriptions-item label="折扣总金额">￥{{ order.discount_price }}</descriptions-item>
        <descriptions-item v-if="order.type != 1" label="下单时间">{{ order.create_time }}</descriptions-item>
        <descriptions-item v-if="order.type != 1" label="支付时间">{{ order.pay_time }}</descriptions-item>
      </descriptions>

    </el-card>

    <el-card>
      <div slot="header" style="display:flex;justify-content:space-between;align-items:center"><span>商品信息</span></div>

      <div v-if="order.type == 1" class="order-item">
        <el-descriptions v-for="(item,index) in order.lists" :key="index" class="margin-top" title="" :column="3" :size="size" border>
          <el-descriptions-item label="订单类型"> {{ item.type==1?'场地':'教练' }}</el-descriptions-item>
          <el-descriptions-item label="订单编号"> {{ item.out_trade_no }}</el-descriptions-item>
          <el-descriptions-item label="订单状态"> {{ item.status_name }}</el-descriptions-item>
          <el-descriptions-item label="场地名称"> {{ item.public_name }}</el-descriptions-item>
          <el-descriptions-item label="教练名称"> {{ item.coach_name || '--' }}</el-descriptions-item>
          <el-descriptions-item label="预约日期"> {{ item.arrange_time }}</el-descriptions-item>
          <el-descriptions-item label="预约时间"> {{ item.start_time }}-{{ item.end_time }}</el-descriptions-item>
          <el-descriptions-item label="订单金额"> ￥{{ item.total_price }}</el-descriptions-item>
          <el-descriptions-item label="实付金额"> ￥{{ item.price }}</el-descriptions-item>
          <el-descriptions-item label="折扣金额"> ￥{{ item.discount_price }}</el-descriptions-item>
          <el-descriptions-item label="支付方式"> {{ item.pay_type_name }}</el-descriptions-item>
          <el-descriptions-item label="下单时间"> {{ item.create_time }}</el-descriptions-item>
          <el-descriptions-item label="支付时间"> {{ item.pay_time }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="order.type == 3" class="order-item">
        <el-descriptions class="margin-top" title="" :column="3" :size="size" border>
          <el-descriptions-item label="会员卡卡种"> {{ order.user_card.member_type_name }}</el-descriptions-item>
          <el-descriptions-item label="价格">￥ {{ order.detail.price }}</el-descriptions-item>
          <el-descriptions-item label="有效天数"> {{ order.user_card.card_days }}</el-descriptions-item>
          <el-descriptions-item label="订场折扣"> {{ order.user_card.space_discount }}</el-descriptions-item>
          <el-descriptions-item label="预约教练折扣"> {{ order.user_card.coach_discount }}</el-descriptions-item>
          <el-descriptions-item label="购买套餐折扣"> {{ order.user_card.combo_discount }}</el-descriptions-item>
          <el-descriptions-item label="订场排队权重"> {{ order.user_card.weight }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="order.type == 4" class="order-item">
        <el-descriptions class="margin-top" title="" :column="3" :size="size" border>
          <el-descriptions-item label="套餐名称"> {{ order.combo.title }}</el-descriptions-item>
          <el-descriptions-item label="教练名称"> {{ order.combo.coach_name }}</el-descriptions-item>
          <el-descriptions-item label="套餐价格"> ￥{{ order.combo.price }}</el-descriptions-item>
          <el-descriptions-item label="课程类型"> {{ order.combo.type }}</el-descriptions-item>
          <el-descriptions-item label="套餐课时"> {{ order.combo.teach_hour }}</el-descriptions-item>
          <el-descriptions-item label="教学人数"> {{ order.combo.teach_number }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div v-if="order.type == 5" class="order-item">
        <el-descriptions class="margin-top" title="" :column="3" :size="size" border>
          <el-descriptions-item :label="order.public_name"> ￥{{ order.price }}</el-descriptions-item>
        </el-descriptions>
      </div>

    </el-card>
    <div style="padding: 15px; text-align: center;">

      <router-link :to="{path:'/order/order'}" class="el-button el-button--primary">返回</router-link>

      <el-button v-if="order.status ===2 || order.status ===3" type="danger" style="height:40px;margin-left:50px;" @click="toRefound()">退款</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/api/order/order'
import Descriptions from '@/components/Descriptions/Descriptions' // 引入组件
export default {
  components: { Descriptions },
  data() {
    return {
      order: {},
      id: '',
      size: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getOrder()
  },
  methods: {
    getOrder() {
      api.orderdetail({ id: this.id }).then((response) => {
        this.order = response.data
      })
    },
    toRefound() {
      this.$confirm('确认要退款吗？').then(_ => {
        api.toRefound({
          out_trade_no: this.order.out_trade_no
        }).then(() => {
          this.getOrder()
          this.$message.success('退款成功')
        })
      }).catch(_ => {})
    }
  }
}
</script>

<style lang="scss" scoped >
.order-item th {
  text-align: center;
}
.el-card {
  margin: 20px;
}
.payInfo {
  width: 50%;
  float: right;
  padding: 40px;
  text-align: right;
}
// 订单列表页样式
.order-item {
  margin-bottom: 10px;
  font-size: 12px;
  color: #3c3c3c;
  .noborder {
    border-right-width: 0;
  }
  .goods-image {
    float: left;
  }
  .goods-info {
    margin-left: 90px;
    text-align: left;
    .goods-title {
      padding: 5px 0;
    }
  }
  .goods-spec {
    color: #9e9e9e;
    padding: 3px;
  }
  .el-link {
    font-size: 12px;
    color: #3c3c3c;
  }
  table {
    width: 100%;
    border-spacing: 0;
    thead {
      background-color: #dfe6ec;
    }
  }
  td {
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid #dfe6ec;
    border-right: 1px solid #dfe6ec;
  }
  th {
    text-align: left;
    padding: 8px;
  }
}
</style>
